import type { AIEntityContext, RangeKey } from "@k8s-dashboard/contracts";
import { useScope } from "@/api/queries";
import { ChatPanel } from "./ChatPanel";

/**
 * Chat Panel 진입점 (ADR 0026 기능 4)
 * --------------------------------------------------------------------------
 * **기능 스위치가 꺼져 있으면 이 컴포넌트는 아무것도 만들지 않습니다** — 버튼도,
 * 패널도, 네트워크 요청도 없습니다. 스위치의 정본은 서버(`/api/v1/scope`의
 * canUseAIChat)이고, 화면은 그 값을 그대로 따릅니다. 브라우저 번들이 자체 판단을
 * 하면 배포마다 다른 상태가 되고, 꺼진 배포에서도 요청이 나갑니다.
 *
 * 아직 모름(pending)과 확인 실패(error)에서도 열지 않습니다 — fail closed입니다.
 *
 * entity는 화면이 **응답에서 읽은 UID**로 만듭니다. URL의 이름은 표시용으로만
 * 넘깁니다(README §5).
 */
export function AgentEntry(props: {
  clusterId: string;
  namespace: string;
  range: RangeKey;
  /** 응답에서 읽은 UID. 없으면 그 축은 넘기지 않습니다. */
  workloadUid?: string;
  podUid?: string;
  subjectName: string;
  subjectKind: string;
}) {
  const scope = useScope();
  const enabled = scope.data?.canUseAIChat === true;
  if (!enabled) return null;

  const entity: AIEntityContext = {
    clusterId: props.clusterId,
    namespace: props.namespace || undefined,
    workloadUid: props.workloadUid || undefined,
    podUid: props.podUid || undefined,
    range: props.range === "custom" ? undefined : props.range,
  };
  return (
    <ChatPanel
      enabled
      entity={entity}
      subjectName={props.subjectName}
      subjectKind={props.subjectKind}
    />
  );
}
